<script setup lang="ts">
import { CreditCard, ShieldCheck, Lock, RotateCcw } from 'lucide-vue-next'
</script>

<template>
  <section class="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-4 md:">
    <div class="flex md: space-x-4 mb-4">
      <div class="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-800 rounded-2xl flex items-center justify-center">
        <CreditCard class="w-8 h-8 text-white" />
      </div>
      <div>
        <h1 class="text-xl md:text-3xl font-bold text-gray-900">Complete Your Subscription</h1>
        <p class="text-gray-600">Secure payment powered by Stripe</p>
      </div>
    </div>
    <div class="flex flex-col md:flex-row md:items-center gap-2 ml-16 md:ml-0 space-x-6 text-sm text-gray-600">
      <div class="flex items-center">
        <ShieldCheck class="w-4 h-4 text-green-600 mr-2" />
        <span>SSL Encrypted</span>
      </div>
      <div class="flex items-center">
        <Lock class="w-4 h-4 text-green-600 mr-2" />
        <span>Secure Payment</span>
      </div>
      <div class="flex items-center">
        <RotateCcw class="w-4 h-4 text-green-600 mr-2" />
        <span>30-Day Money Back</span>
      </div>
    </div>
  </section>
</template>
